<template>
    <div class="procurementCatalogDetail">
        <HeaderNav
            header-title="采购合同详情"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="content">
            <div class="tab_box">
                <van-tabs
                    color="#e93743"
                    v-model="tabActive"
                    @click="tabSelect"
                >
                    <template v-for="(item, index) in tabData">
                        <van-tab
                            :key="index"
                            :title="item.name"
                            :disabled="item.disabled"
                        ></van-tab>
                    </template>
                </van-tabs>
            </div>
            <section class="main-wrapper">
                <div class="box-wrapper">
                    <component :is="currentView"></component>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import ContractInfo from '@/views/purchase/procurementCatalog/ContractInfo';
import MaterialPrice from '@/views/purchase/procurementCatalog/MaterialPrice';
import CountersignContract from '@/views/purchase/procurementCatalog/CountersignContract';
import attachment from '@/views/purchase/procurementCatalog/attachment';
export default {
    name: 'procurement-catalog',
    components: {
        HeaderNav,
        ContractInfo,
        MaterialPrice,
        CountersignContract,
        attachment,
    },
    data() {
        return {
            tabActive: 0,
            currentView: 'ContractInfo',
            // tab选项
            tabData: [
                {
                    name: '合同信息表',
                    disabled: false,
                    value: 'ContractInfo',
                },
                {
                    name: '物料价格信息',
                    disabled: false,
                    value: 'MaterialPrice',
                },
                {
                    name: '合同会签表',
                    disabled: false,
                    value: 'CountersignContract',
                },
                {
                    name: '附件资料',
                    disabled: false,
                    value: 'attachment',
                },
            ],
        };
    },
    watch: {},
    created() {},
    mounted() {},
    computed: {},
    methods: {
        // 图表切换
        tabSelect(i) {
            this.currentView = this.tabData[i].value;
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.procurementCatalogDetail
    height 100%
    .content
        height calc(100% - 44rpx)
        margin-top 44rpx
        >>>.van-tab--active
            color #e93743 !important
        >>>.van-tabs__line
            width 80px !important
        section
            height calc(100% - 44rpx)
            .box-wrapper
                height 100%
</style>
